import { createSelector } from 'reselect';

const getUserOrganizations = (state) => state.organizationsReducer.userOrganizations;
export const selectOrganizationLoading = (state) => state.organizationsReducer.userOrganizationsFetched;
export const selectCurrentOrganization = (state) => state.organizationsReducer.currentOrganization;
export const selectFilterDropdownValues = (state) => state.organizationsReducer.filterDropdownValues;
export const selectSkills = (state) => state.skillsReducer.skills;

export const selectCurrentOrganizationLoading = (state) => state.organizationsReducer.currentOrganizationLoading;
export const getUserOrganizationsMemoized = createSelector(
  [getUserOrganizations],
  (userOrganizations) => userOrganizations
);
